import { cn } from '@app/utils/cn';
import { handleEscapeKey } from '@app/utils/handleEscapeKey';
import { isDefined } from '@app/utils/is';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

interface Props {
  title?: React.ReactNode;
  isOpen: boolean;
  style?: React.CSSProperties;
  className?: string;
  onClose?: () => void;
}

export const DropdownPopover = React.forwardRef<HTMLDivElement, React.PropsWithChildren<Props>>(
  ({ isOpen, children, style, className, onClose, title }, ref) => {
    return (
      <CSSTransition
        in={isOpen}
        timeout={150}
        unmountOnExit
        classNames={{
          enter: 'opacity-0 scale-90',
          enterActive: '!opacity-100 !scale-100 transition-[opacity,transform]',
          exit: 'opacity-100 scale-100',
          exitActive: '!opacity-0 !scale-90 transition-[opacity,transform]',
        }}
      >
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div
          ref={ref}
          style={style}
          onKeyDown={handleEscapeKey(onClose)}
          className={cn('z-popover max-h-[50vh] overflow-auto rounded-regular bg-white p-2 shadow-2', className)}
        >
          {isDefined(title) && (
            <h3 data-sentry-mask className="mx-2 mb-1 body-7">
              {title}
            </h3>
          )}
          {children}
        </div>
      </CSSTransition>
    );
  },
);
